import React from 'react'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import InvoicePackagePageContent from '../../components/InvoicePackagePageContent'
import Configuration from '../../Services/Api/Configuration'

const InvoicePackages = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Page.invoicePackages.title' })}
           pathname={window.location.origin + NamedRoutes.invoicePackages}
           titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
           description={intl.formatMessage({ id: 'Page.invoicePackages.title' })}
      />

      <AccountLayout permission={Configuration.permissions.invoicePackages} content={
        <InvoicePackagePageContent/>
      }/>
    </>
  )
}

export default InvoicePackages
